import { render, staticRenderFns } from "./UserProfileChange.vue?vue&type=template&id=5b2d5bb6&scoped=true&lang=pug&"
import script from "./UserProfileChange.vue?vue&type=script&lang=js&"
export * from "./UserProfileChange.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileChange.vue?vue&type=style&index=0&id=5b2d5bb6&prod&lang=scss&scoped=true&"
import style1 from "./UserProfileChange.vue?vue&type=style&index=1&id=5b2d5bb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2d5bb6",
  null
  
)

export default component.exports